var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.502 18.361a1.9 1.9 0 0 0 1.901-1.895v0c0-.533-.213-1.043-.591-1.42l-1.26-1.26v-3.744A5.547 5.547 0 0 0 13 4.496v0a5.546 5.546 0 0 0-5.543 5.546v3.741l-1.26 1.26a2.007 2.007 0 0 0-.592 1.42v0a1.9 1.9 0 0 0 1.9 1.895z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52 21.504h2.959"
  }))));
};
export { SvgAlert as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMjQ4MmY3MjI2ZTA4NTJmZWIxZTU0NzcxZDMxYzVjYmQuc3ZnIjs=";